import { render, staticRenderFns } from "./ugc.vue?vue&type=template&id=337f9430&scoped=true&"
import script from "./ugc.vue?vue&type=script&lang=js&"
export * from "./ugc.vue?vue&type=script&lang=js&"
import style0 from "./ugc.vue?vue&type=style&index=0&id=337f9430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f9430",
  null
  
)

export default component.exports